export default "__VITE_ASSET__BVVhnfHG__"